module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "upgrade-project-dialog",
    attrs: {
      "title": _vm.$t(_vm.operator === 'upgrade' ? 'upgradeProject' : 'unlockProject'),
      "size": "small",
      "visible": _vm.dialogVisable
    },
    on: {
      "close": _vm.close,
      "update:visible": function($event) {
        _vm.dialogVisable = $event
      }
    }
  }, [_c('p', [_vm._v("\n    " + _vm._s(_vm.operator === 'upgrade' ? _vm.$t('upgradeHint') : _vm.$t('unlockHint')) + "\n  ")]), _vm._v(" "), (_vm.permanentsLeft !== 0) ? _c('div', {
    staticClass: "has-quotas"
  }, [_c('el-checkbox', {
    attrs: {
      "theme": "info",
      "checked": true,
      "disabled": true
    }
  }, [_vm._v("\n      使用账号额度（" + _vm._s(_vm.permanentsLeft === null ? '不限次数' : ("还剩" + _vm.permanentsLeft + "次")) + "）\n    ")])], 1) : (!_vm.organization) ? _c('el-form', {
    attrs: {
      "label-thin": "",
      "label-width": "66px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "金额"
    }
  }, [_c('el-radio-group', {
    staticClass: "package-type",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.packageType),
      callback: function($$v) {
        _vm.packageType = $$v
      },
      expression: "packageType"
    }
  }, [(!_vm.logoEnabled) ? _c('el-radio-button', {
    attrs: {
      "label": "one_time_permanent_logo"
    }
  }, [_vm._v("\n          ￥99/永久" + _vm._s(_vm.$t('common.project')) + "+去除加载页LOGO "), _c('span', {
    staticClass: "recommand"
  }, [_vm._v("限时优惠")])]) : _vm._e(), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "one_time_permanent"
    }
  }, [_vm._v("\n          ￥49/" + _vm._s(_vm.$t('common.project')) + "\n        ")])], 1), _vm._v(" "), _c('a', {
    staticClass: "price-link",
    attrs: {
      "href": "/price?closeOnPQuota=true",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "ppj-icon-gift"
  }), _vm._v("升级会员，套餐更优惠")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('common.order.labels.payType')
    }
  }, [_c('el-radio-group', {
    staticClass: "payment",
    attrs: {
      "theme": "info"
    },
    model: {
      value: (_vm.payType),
      callback: function($$v) {
        _vm.payType = $$v
      },
      expression: "payType"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "wechat"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.wechat')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "alipay"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.order.alipay')))])], 1)], 1)], 1) : _c('div', [(_vm.overdate) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("企业套餐已过期，请联系管理员续费或升级")]) : _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("企业套餐额度不足，请联系管理员续费或升级")])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [(_vm.organization && _vm.permanentsLeft === 0) ? _c('div', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))])], 1) : _c('div', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.placeOrder()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.buttons.submit')))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d9149c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/project/upgrade.dialog.vue
// module id = 894
// module chunks = 3